import { render } from "./Parameter.vue?vue&type=template&id=4a6bbaf1&scoped=true"
import script from "./Parameter.vue?vue&type=script&lang=js"
export * from "./Parameter.vue?vue&type=script&lang=js"

import "./Parameter.vue?vue&type=style&index=0&id=4a6bbaf1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6bbaf1"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QForm,QBanner,QInnerLoading,QSpinnerGears});
